@import '../../../../constants/spacing.module.less';

.summary-section {
  display: flex;
  flex-direction: column;
  gap: @space-16;
}

.order-summary {
  padding: @space-0;
}

.display-summary-message {
  display: inline-block;
  font-size: 14px;
  line-height: 24px;
}
